const ax = (props) => props.children;

export default ax;